var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"film fixed overlay bg-vanilla flex p-48"},[(_vm.doc)?_c('div',{staticClass:"relative w-full"},[_c('vimeo-player',{attrs:{"vimeoURL":_vm.doc.data.vimeo_url,"bgSize":"contain"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }